<template>
  <el-aside class="slide-bar"
            :width="isCollapse ? '65px' : '226px'">
    <el-menu class="slide-menu"
             :default-active="active"
             :unique-opened="true"
             :collapse="isCollapse">
      <template v-for="(item, index) in menuList">
        <el-menu-item v-if="!item.children"
                      :key="index"
                      :index="String(index)"
                      @click="handleJump(item.uri)">
          <i :class="item.icon"></i>
          <span slot="title">{{ item.name }}</span>
        </el-menu-item>
        <el-submenu v-else
                    :key="index"
                    :index="String(index)">
          <template slot="title">
            <i :class="item.icon"></i>
            <span>{{ item.name }}</span>
          </template>
          <el-menu-item v-for="list in item.children"
                        :key="list.uri"
                        :index="list.uri"
                        @click="handleJump(list.uri)">{{ list.name }}
          </el-menu-item>
        </el-submenu>
      </template>
    </el-menu>
    <span class="expand-container"
          :class="[isCollapse ? 'active' : '']"
          @click="handleExpand">
      <i :class="[isCollapse ? 'el-icon-d-arrow-right' : 'el-icon-d-arrow-left']"></i></span>
  </el-aside>
</template>

<script>
import fetch from '@/common/api'
// import { menuList } from '@/common/menu'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      active: '',
      menuList: [],
      isCollapse: false
    }
  },
  computed: {
    ...mapState({
      isfreshMenu: (state) => state.isfreshMenu,
      theme: (state) => state.theme
    })
  },
  created() {
    this.getList()
    this.active = this.$route.path
  },
  watch: {
    isfreshMenu(val) {
      if (val) {
        this.getList()
        this.$store.commit('freshMenu', { flag: false })
      }
    }
  },
  methods: {
    // 获取列表
    getList() {
      fetch.getMenu({ id: localStorage.getItem('uId') }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.menuList = data.treeData
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 控制展开收缩
    handleExpand() {
      this.isCollapse = !this.isCollapse
    },
    handleJump(path) {
      this.$router.push({
        path: path
      })
    }
  }
}
</script>

<style lang="less" scoped>
.slide-bar {
  transition: all, 0.3s;
  border-right: 1px solid #409eff;
  overflow-x: hidden;
  overflow-y: auto;
  .slide-menu:not(.el-menu--collapse) {
    width: 225px;
  }
  .expand-container {
    background: #8cbcff;
    position: absolute;
    top: 50%;
    left: 225px;
    display: inline-block;
    height: 50px;
    line-height: 50px;
    cursor: pointer;
    border: 1px solid #409eff;
    border-left: none;
    border-radius: 0 5px 5px 0;
    transition: left, 0.3s;
    &.active {
      left: 64px;
    }
  }
}
.slide-menu {
  font-weight: bold;
}
.el-menu-item {
  color: rgb(99, 99, 99);
  font-weight: 100;
}
</style>
